/* (ignored) */


//////////////////
// WEBPACK FOOTER
// util (ignored)
// module id = 0
// module chunks = main polyfills